import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function Discounts({ children }) {
  useInjectSaga({ key: 'settingsDiscounts', saga });
  useInjectReducer({ key: 'settingsDiscounts', reducer });

  return React.Children.only(children);
}

Discounts.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as withDiscounts } from './withDiscounts';
export default compose(withConnect, memo)(Discounts);
